import { Box, Skeleton } from "@mui/material";

export const ObjectsPlaceholderCard = () => (
  <Box
    sx={{
      p: 2,
      borderRadius: 2,
      border: "1px solid rgba(var(--fx-surface-textrgb, 15, 23, 42), 0.1)",
      bgcolor: "var(--fx-surface-base, #FFFFFF)",
    }}
  >
    <Skeleton variant="rectangular" width="100%" height={120} sx={{ mb: 1 }} />

    <Skeleton variant="text" width="80%" height={20} />

    <Skeleton variant="text" width="60%" height={18} sx={{ mt: 1 }} />
  </Box>
);
